import { createCrudSlice } from '../createCrudSlice';
import usersService from '@/services/users.service';

// list + create/update/delete. One-off actions (block, grantPro, forceLogout) are called
// directly via usersService in page handlers, then the list is re-fetched.
const { reducer, thunks, actions } = createCrudSlice('users', usersService);

export const { fetchList: fetchUsers, createItem: createUser, updateItem: updateUser, deleteItem: deleteUser } = thunks;
export const { resetError } = actions;
export default reducer;
